// src/pages/ShippingPolicy.js
import CmsPage from "../components/pages/CmsPage";

export default function ShippingPolicy() {
  return (
    <CmsPage
      slug="shipping_policy"
      fallbackTitle="Shipping Policy"
      fallbackContent=""
    />
  );
}
